import { useMemo } from 'react';
import produce from 'immer';

import useFormState from '../../../../../hooks/product/useFormState';

const useFormPropertyState = (initialValue, propertyList, config) => {
  const initPropertyList = useMemo(() => {
    return produce(initialValue, (draft) => {
      for (const key in propertyList) {
        draft[key] = {
          name: propertyList[key].name,
          list: initialValue[key].list.active.map((item) => ({ id: item.id, name: item.name })),
        };
      }
    });
  }, [initialValue, propertyList]);

  const result = useFormState(initPropertyList, config);
  return result;
};

export default useFormPropertyState;
